export default __webpack_public_path__ + "static/media/CA.f81cb3f5.svg";